export const tabsInjectionKey = Symbol('tabs');
